import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { ToasterService } from "../../../services/toaster/toaster.service";
import { hallsAPI } from "../api/api";
import { HallsActionTypes } from "../actions/actionTypes";
import { STARTING_PAGE, PAGE_SIZE } from "./../reducers/hallsList.reducer";
import { hallsStoreSelectors } from "../store/store";
import { push } from "react-router-redux";

import { configurationsStore } from "../../configurations/store/store";
import { ConfigurationsActionCreators } from "../../configurations/actions/actionCreators";

function* uploadConfiguration(action) {
    try {
        const uploadedJson = yield call(() =>
            hallsAPI.uploadConfiguration(
                action.payload.file,
                action.payload.server_id
            )
        );

        if (uploadedJson.data.basic.type != action.payload.server_type) {
            ToasterService.errorToast("Server type don't match.");

            yield put({
                type: HallsActionTypes.UPLOAD_CONFIGURATION_FAIL
            });
        } else if (
            uploadedJson.data.basic.hall.subsidiary.id !=
            action.payload.subsidiary
        ) {
            ToasterService.errorToast("Hall subsidiary does not match.");

            yield put({
                type: HallsActionTypes.UPLOAD_CONFIGURATION_FAIL
            });
        } else {
            yield put({
                type: HallsActionTypes.CREATION_MODE_CHANGE,
                payload: {
                    mode: null
                }
            });

            configurationsStore.dispatch(
                ConfigurationsActionCreators.setUploadConfiguration(
                    uploadedJson.data
                )
            );

            yield put(
                push(`/configurations/upload/${action.payload.server_id}`)
            );
        }
    } catch (e) {
        API.handleError(e.response, "Error in configuration uploaded file.");

        yield put({
            type: HallsActionTypes.UPLOAD_CONFIGURATION_FAIL,
            message: e.message
        });
    }
}

export function* uploadConfigurationWatcher() {
    yield takeLatest(
        HallsActionTypes.UPLOAD_CONFIGURATION,
        uploadConfiguration
    );
}
